import R from 'ramda'

import fetchQueries from './fetchQueries'
import toggleLoginRequiredModal from './toggleLoginRequiredModal'

export default () => (dispatch, getState) => {
  const state = getState()
  const userName = R.path(['session', 'userName'], state)
  const token = R.path(['session', 'token'], state)

  if(!token || !userName){
    dispatch(toggleLoginRequiredModal())
    return
  }
  dispatch({type: 'toggle_my_queries_modal'})
  dispatch(fetchQueries())
}



/** WEBPACK FOOTER **
 ** ./app/actions/toggleMyQueriesModal.js
 **/